import { cn } from "@omni/utils/styles";

import { CurrentLocationLink } from "@/components/CurrentLocationLink/currentLocationLink.component";
import { useStoreSearchInputContext } from "@/components/Store/StoreSearchInput/context/storeSearchInput.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const Location = ({ className }: Props) => {
    const { t } = useGranite();

    const { onLocationError, onUseLocation } = useStoreSearchInputContext();

    return (
        <CurrentLocationLink
            className={cn("tw:text-left", className)}
            label={t("form.searchstore.useCurrentLocation")}
            onCurrentLocationError={onLocationError}
            onCurrentLocationSuccess={onUseLocation}
        />
    );
};
